var _excluded = ["entity", "subtype"],
  _excluded2 = ["product"];
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
export var entities = {
  product: function product(model) {
    return {
      product: model
    };
  },
  subscription: function subscription(_ref) {
    var entity = _ref.entity,
      subtype = _ref.subtype,
      rest = _objectWithoutProperties(_ref, _excluded);
    return {
      product: {
        entity: entity,
        subtype: subtype
      },
      subscription: rest
    };
  },
  portfolio: function portfolio(_ref2) {
    var product = _ref2.product,
      rest = _objectWithoutProperties(_ref2, _excluded2);
    return {
      product: {
        entity: product,
        subtype: rest.type
      },
      portfolio: rest
    };
  }
};
export var getEntity = function getEntity(model, modelType) {
  return entities[modelType](model);
};
export var getEntities = function getEntities(models, modelType) {
  return models.map(function (model) {
    return getEntity(model, modelType);
  });
};